const Theme = {
  logo_image_url: 'afl.png',
  logo_height: 200,

  token_url: 'afl.png',
  token_width: 70,
  token_margin_left: 10,
  token_margin_right: 10,
  token_margin_top: -3,

  body_background_color: '#F8EFE5',

  title_color: '#0C4615',
  subtitle_color: '#0C4615',
  subtitleH3_color: '#000000',

  button_color: '#0c4615',
  button_radius: 20,
  
  text_font: 'Roboto Condensed',
  title_font: 'Roboto Condensed',
}

export default Theme
//https://app.clickup.com/t/86dy6rdzk